module.exports = __webpack_public_path__ + "img/login_bg.35457008.jpg";